import {SiteEntity, SiteSelectorProps, sitesSelector, useGetAllSitesQuery} from "@ots-frontend/ots-data";
import {BaseSiteMultiSelect, BaseSiteMultiSelectProps} from "./BaseSiteMultiSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type SiteMultiSelectProps = Omit<BaseSiteMultiSelectProps, "entities" | "loading"> & {
    selector?: SiteSelectorProps
}

export const SiteMultiSelect = (props: SiteMultiSelectProps) => {
    const {
      selector,
      ...rest} = props;

    const selectSites = useMemo(() => {
        return sitesSelector()
    }, []);

    const {sites, isLoading} = useGetAllSitesQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            sites: selectSites(result, selector),
            isLoading: result.isLoading
        })
    });

    return <BaseSiteMultiSelect entities={sites} loading={isLoading} {...rest} />;
};

export interface SiteMultiSelectModalProps extends Omit<ModalProps, "onSubmit"> {
    select?: SiteMultiSelectProps,
    onSubmit?: (sites: SiteEntity[] | undefined) => void
}

export const SiteMultiSelectModal = (props: SiteMultiSelectModalProps) => {
    const {
        select,
        onSubmit,
        ...rest
    } = props;

    const [selectedSites, setSelectedSites] = useState<SiteEntity[]>([])

    const {t} = useTranslation(["common"]);

    return (
        <Modal {...rest}>
            <Box>
                <SiteMultiSelect
                    {...select}
                    onEntityChange={e => setSelectedSites(e)}/>
                <Button type="submit" mt="xl" onClick={(e) => {
                    if (onSubmit) {
                        onSubmit(selectedSites);
                    }
                }}>
                    {t("common.action.submit")}
                </Button>
            </Box>
        </Modal>
    );
};
